import * as Sentry from '@sentry/react';

export type DiagnosticLevel = 'info' | 'warning' | 'error';

/**
 * Centralized diagnostic telemetry for frontend components and hooks.
 * Directs diagnostics to Sentry breadcrumbs instead of polluting raw browser consoles in production.
 */
export function recordClientDiagnostic(
  message: string,
  context?: Record<string, unknown>,
  level: DiagnosticLevel = 'info'
): void {
  try {
    const sentryLevel: Sentry.SeverityLevel =
      level === 'error' ? 'error' : level === 'warning' ? 'warning' : 'info';

    Sentry.addBreadcrumb({
      category: 'client_diagnostic',
      message,
      level: sentryLevel,
      data: context
    });
  } catch {
    // Safe fallback if telemetry has not initialized yet
  }
}
